import { Component, ViewEncapsulation } from '@angular/core';
import { NavController, ModalController, AlertController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Storage } from '@ionic/storage';
import { get, trim } from 'lodash';
import { Router } from '@angular/router';
import ErrorHandler from '../../lib/error-handler'

import { AppState, NativeClientService } from '../services';
import { MaintenanceModal } from '../maintenance-modal/maintenance-modal';
declare var Penmate;
declare var Beacon

/*
  Generated class for the Login page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
// Record names arrive as "LAST, FIRST" as often as "First Last".
const firstNameFrom = (name): string => {
  const raw = trim(name || '');
  if (raw.indexOf(',') > -1) return trim(raw.split(',')[1] || '');
  return raw.split(' ')[0] || '';
};

@Component({
  selector: 'pm-login-page',
  templateUrl: 'login.page.html',
  styleUrls: ['./login.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginPage {
  modal: any;
  currentSearch;
  savedSearchResult;
  searchName;
  // The person the visitor was about to search for, by first name, for the
  // continuation copy.
  searchFirstName;
  savedSearchQuery;
  scriptLoaded;
  loginError;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public store: Store<AppState>,
    private storage: Storage,
    public alertCtrl: AlertController,
    private nativeService: NativeClientService,
    private router: Router,
  ) {

    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state;
    this.savedSearchQuery = get(state, 'searchQuery');

    if (this.savedSearchQuery) {
      const { first_name, last_name } = this.savedSearchQuery;
      this.searchName = `${first_name} ${last_name}`;
      this.searchFirstName = trim(first_name || '');
    }

    this.store
      .select(state => ({
        currentSearch: state.search.currentSearch,
        savedSearch: state.savedSearch,
      }))
      .subscribe(({ currentSearch, savedSearch }) => {
        this.currentSearch = currentSearch;
        this.savedSearchResult = get(savedSearch, 'savedSearchResult');
        // A draft that just arrived with this navigation is the person the
        // visitor means; a saved result persisted from an earlier visit must
        // not overwrite it.
        if (this.savedSearchResult && !this.savedSearchQuery) {
          const result = this.savedSearchResult;
          this.searchName = trim(
            result.first_name ? `${result.first_name} ${result.last_name}` : result.name,
          );
          this.searchFirstName = result.first_name
            ? trim(result.first_name)
            : firstNameFrom(result.name);
        }
      });
  }


  ionViewDidEnter() {
    Beacon('destroy')
    if (this.nativeService.active) {
      return this.nativeService.sendMessage({ type: 'LOGOUT' });
    }

    const parsedHash = new URLSearchParams(
      window.location.hash.substring(1) 
    );

    if (parsedHash && parsedHash.get('error_description')) {
      this.loginError = parsedHash.get('error_description')
      return this.onShowLoginError(this.loginError);
    }

    const url = new URL(window.location.href);
    const showSupport = url.searchParams.get("support");
    if (!!showSupport) {
      Beacon('init', Penmate.env.helpScoutId);
      Beacon('prefill', {
        subject: `Login Help`,
        fields: [
          {
            id: 51200,
            value: 274542
          },
        ]
      })
      Beacon('open');
      Beacon('navigate', '/ask/message/');
    }
  }

  async onShowLoginError(errorText) {
    const confirmRemove = await this.alertCtrl.create({
      header: 'Login Error',
      message: `${errorText}.   Please try again or contact support.`,
      buttons: [
        {
          text: 'Contact Support',
          handler: () => {
            Beacon('init', Penmate.env.helpScoutId);
            Beacon('open');
            Beacon('navigate', '/ask/message/');
          },
        },
        {
          text: 'Try again',
          cssClass: 'ok',
          handler: () => {
          },
        },
      ],
    });
    await confirmRemove.present();
    setTimeout(() => {
      Beacon('init', Penmate.env.helpScoutId);
    }, 1500);
  }

  login() {
    this.navCtrl.navigateForward('/signin');
    // this.modal = this.modalCtrl.create({
    //   component: ClerkLoginModal,
    // }).then(async (modal) => {
    //   await modal.present();
    // })
  }
}
